import { Injectable } from '@angular/core';
import {
  MyHttpClientFactory,
  ResponseCasingEnum,
  environment,
} from '@ups/xplat/core';
import { HttpClient } from '@angular/common/http';
import { LineOfBusinessDto } from '@ups/xplat/api/dto';

/** @deprecated Used by legacy QuoteLog form. For SRF use service-request.service.ts::getServiceDropdowns() */
@Injectable({
  providedIn: 'root',
})
export class LineOfBusinessVPService {
  private vpHttp: HttpClient;

  constructor(private clientFactory: MyHttpClientFactory) {
    this.vpHttp = this.clientFactory.createHttpClient(
      environment.urls.viewpointAPI,
      true,
      ResponseCasingEnum.CamelCase
    );
  }
  /** @deprecated Used by legacy QuoteLog form. For SRF use service-request.service.ts::getServiceDropdowns() */
  get() {
    return this.vpHttp.get<LineOfBusinessDto[]>(
      `/api/quotelog/linesOfBusiness`
    );
  }
}
